




































import { computed, defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'AProductReviewSummary',

  props: {
    rating: {
      type: Number,
      default: 0,
    },
    countFiltered: {
      type: Number,
      default: 0,
    },
    countAll: {
      type: Number,
      default: 0,
    },
  },

  emits: ['click'],

  setup(props) {
    const percentage = computed(() => {
      if (props.countAll > 0) {
        return Math.round((100 / props.countAll) * props.countFiltered)
      } else {
        return 0
      }
    })

    return { percentage }
  },
})
